const NotificationPanel = ({ children, className, ...props }) => (
  <div className={`notification-panel overflow-y-auto ${className}`} {...props}>
    {children}
  </div>
);

export default NotificationPanel;
